function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2967 12.9061C19.2967 16.8599 16.0495 20.0807 12.0243 20.0807C7.99922 20.0807 4.75195 16.8599 4.75195 12.9061C4.75195 8.95228 7.99922 5.73145 12.0243 5.73145C16.0495 5.73145 19.2967 8.95228 19.2967 12.9061Z",
  stroke: "#8C8C8C",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11.0215,
  y: 3,
  width: 2.0056,
  height: 2.97173,
  rx: 0.5,
  fill: "#8C8C8C"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 13.5293,
  y: 3,
  width: 1.98116,
  height: 3.0084,
  rx: 0.5,
  transform: "rotate(90 13.5293 3)",
  fill: "#8C8C8C"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 11.2734,
  y: 7.95312,
  width: 1.5042,
  height: 5.94347,
  rx: 0.5,
  fill: "#8C8C8C"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 1.49395,
  height: 4.68336,
  rx: 0.5,
  transform: "matrix(-0.549767 0.835318 -0.841948 -0.539559 15.8711 14.832)",
  fill: "#8C8C8C"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 1.99341,
  height: 3.98683,
  rx: 0.5,
  transform: "matrix(0.711429 -0.702758 0.711429 0.702758 14.7539 19.1982)",
  fill: "#8C8C8C"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 1.99341,
  height: 3.98683,
  rx: 0.5,
  transform: "matrix(-0.711429 -0.702758 -0.711429 0.702758 9.25977 19.1982)",
  fill: "#8C8C8C"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 1.99341,
  height: 4.98354,
  rx: 0.5,
  transform: "matrix(0.711429 -0.702758 0.711429 0.702758 16.0371 4.40137)",
  fill: "#8C8C8C"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 1.99341,
  height: 4.98354,
  rx: 0.5,
  transform: "matrix(-0.711429 -0.702758 -0.711429 0.702758 7.96289 4.40137)",
  fill: "#8C8C8C"
});

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.34a2c402.svg";
export { ForwardRef as ReactComponent };